import { ApplicationState } from '../../../../store/types';
import { getResetPasswordRoot } from '../../store/selectors';

export const getCurrentPassword = (state: ApplicationState): string => getResetPasswordRoot(state).currentPassword;
export const getNewPassword = (state: ApplicationState): string => getResetPasswordRoot(state).newPassword;
export const getConfirmNewPassword = (state: ApplicationState): string => getResetPasswordRoot(state).confirmNewPassword;

export const getPasswordScore = (state: ApplicationState): number => getResetPasswordRoot(state).passwordScore;

export const getPasswordIsStrongEnough = (state: ApplicationState): boolean => {
    const passwordScore = getPasswordScore(state);
    return passwordScore > 2;
};

export const getErrorMessage = (state: ApplicationState): string | null => getResetPasswordRoot(state).errorMessage;

export const getIsResettingPassword = (state: ApplicationState): boolean => getResetPasswordRoot(state).resettingPassword;
